<template>

</template>

<script>
    export default {
        name: "WorkspaceMenubar",
        mounted: function() {
            this.$nextTick(() => {
            });
        },
        methods: {}
    }
</script>

<style scoped>

</style>